/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormatter } from '../../../../utils/formatting';

const MallCertificate = ({
  tenderInfo,
}) => {
  const {
    locale: { storeCurrency, storeLocale }, RL_MallCertificate
  } = useSelector((state) => state);

  return (
    <>
      <article className="justify-between">
        <p>{RL_MallCertificate}</p>
        <p>
          {currencyFormatter(
            storeLocale,
            storeCurrency,
            tenderInfo.Tender?.Amount?.Amount,
          )}
        </p>
      </article>
      <article className="justify-between">
        <p className="pl2-sm">{`Serial Number: ${tenderInfo.Tender?.Voucher?.SerialNumber || ''}`}</p><p />
      </article>
      <br />
    </>
  );
};

MallCertificate.defaultProps = {
  tenderInfo: {},
};

MallCertificate.propTypes = {
  tenderInfo: PropTypes.shape(),
};

export default MallCertificate;
